
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"20","width":"20","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 -960 960 960"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M217-421v-118h526v118H217z","fill":"#fff"}})])
          )
        }
      }
    